<template>
    <!-- 管理员-过程管理/考勤管理 -->
    <div class="attendance-manage wrapper" v-loading="loading">
        <proTitle></proTitle>

        <div class="page-header flex-align-between">
            <div class="page-title">每日考勤查询</div>
            <div class="header-date" v-if="formInline.date">
                {{ headerDateText }}
                <span class="weekday">{{ headerWeekday }}</span>
            </div>
        </div>

        <el-tabs v-model="attendanceType" @tab-click="onTypeChange">
            <el-tab-pane label="上午考勤" name="0"></el-tab-pane>
            <el-tab-pane label="住宿考勤" name="2"></el-tab-pane>
        </el-tabs>

        <div class="table_section">
            <el-form :inline="true" class="demo-form-inline flex-between" @submit.native.prevent>
                <div class="formInline-left">
                    <el-form-item>
                        <el-radio-group v-model="mode" size="small" @change="onModeChange">
                            <el-radio-button label="detail">考勤明细</el-radio-button>
                            <el-radio-button label="missing">未打卡名单</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-date-picker v-model="formInline.date" type="date" size="small" value-format="yyyy-MM-dd"
                            placeholder="选择日期" :clearable="false" style="width: 160px"
                            @change="onFilterChange"></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="formInline.stageId" size="small" clearable placeholder="全部阶段"
                            style="width: 140px" @change="onFilterChange">
                            <el-option label="全部阶段" value=""></el-option>
                            <el-option v-for="item in stageOptions" :key="item.stageId" :label="item.stageName"
                                :value="item.stageId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="mode === 'detail'">
                        <el-select v-model="formInline.statusCode" size="small" clearable placeholder="全部状态"
                            style="width: 130px" @change="onFilterChange">
                            <el-option label="全部状态" value=""></el-option>
                            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="formInline.keyword" size="small" clearable
                            placeholder="搜索姓名 / 手机号 / 学校" suffix-icon="el-icon-search" style="width: 220px"
                            @input="onSearchInput" @clear="onFilterChange"></el-input>
                    </el-form-item>
                </div>
                <div class="formInline-right">
                    <el-button type="primary" size="small" icon="el-icon-download" :loading="exporting"
                        @click="exportDaily">{{ exportBtnText }}</el-button>
                </div>
            </el-form>

            <div class="daily-tip" v-if="tipText" v-html="tipText"></div>

            <el-table :data="tableData" border style="width: 100%">
                <el-table-column type="index" label="序号" width="70" align="center" :index="indexMethod"></el-table-column>
                <el-table-column prop="userName" label="教师姓名" align="center" min-width="110" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.userName || '--' }}</template>
                </el-table-column>
                <el-table-column prop="phone" label="手机号" align="center" width="130" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.phone || '--' }}</template>
                </el-table-column>
                <el-table-column prop="schoolName" label="所在学校" align="center" min-width="140" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.schoolName || '--' }}</template>
                </el-table-column>
                <el-table-column prop="stageName" label="所属阶段" align="center" min-width="110" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.stageName || '--' }}</template>
                </el-table-column>
                <el-table-column prop="expectTimeRange" label="应打卡时段" align="center" width="130">
                    <template slot-scope="scope">{{ scope.row.expectTimeRange || '--' }}</template>
                </el-table-column>
                <el-table-column prop="statusName" label="打卡状态" align="center" width="100">
                    <template slot-scope="scope">
                        <span class="status-badge" :class="scope.row.statusCode">
                            {{ scope.row.statusName || '--' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column v-if="mode === 'detail'" prop="checkTime" label="打卡时间" align="center" width="120">
                    <template slot-scope="scope">{{ scope.row.checkTime || '--' }}</template>
                </el-table-column>
                <el-table-column v-if="mode === 'detail'" prop="location" label="打卡位置" align="center" min-width="140"
                    show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.location || '--' }}</template>
                </el-table-column>
            </el-table>

            <pagination :total="pages.total" :page.sync="pages.currentPage" :limit.sync="pages.pageSize"
                :pageSizes="[10, 20, 30]" @pagination="handlePageChange"></pagination>
        </div>
    </div>
</template>

<script>
    import { saveAs } from 'file-saver'

    const WEEKDAY_LABELS = ['日', '一', '二', '三', '四', '五', '六']
    const STATUS_OPTIONS = [
        { label: '已打卡', value: 'checked' },
        { label: '未打卡', value: 'missing' },
        { label: '迟到', value: 'late' },
        { label: '请假', value: 'leave' },
        { label: '未开始', value: 'pending' },
    ]

    const formatDate = (dateObj) => {
        const y = dateObj.getFullYear()
        const m = String(dateObj.getMonth() + 1).padStart(2, '0')
        const d = String(dateObj.getDate()).padStart(2, '0')
        return `${y}-${m}-${d}`
    }

    export default {
        data() {
            return {
                loading: false,
                exporting: false,
                attendanceType: '0',
                mode: 'detail',
                stageOptions: [],
                statusOptions: STATUS_OPTIONS,
                attendanceDates: [],
                tableData: [],
                tipText: '',
                searchTimer: null,
                formInline: {
                    date: '',
                    stageId: '',
                    statusCode: '',
                    keyword: '',
                },
                pages: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                },
            }
        },
        computed: {
            projectId() {
                return this.$store.state.user.currentProject && this.$store.state.user.currentProject.id
            },
            exportBtnText() {
                return this.mode === 'missing' ? '导出未打卡名单' : '导出明细'
            },
            headerDateText() {
                if (!this.formInline.date) return '—'
                const parts = this.formInline.date.split('-')
                return `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日`
            },
            headerWeekday() {
                if (!this.formInline.date) return ''
                const parts = this.formInline.date.split('-')
                const dateObj = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]))
                if (isNaN(dateObj.getTime())) return ''
                return `星期${WEEKDAY_LABELS[dateObj.getDay()]}`
            },
        },
        methods: {
            indexMethod(index) {
                return this.pages.currentPage > 1
                    ? this.pages.pageSize * (this.pages.currentPage - 1) + index + 1
                    : index + 1
            },
            buildQueryParams(withPage = true) {
                const params = {
                    projectId: this.projectId,
                    date: this.formInline.date,
                    attendanceType: Number(this.attendanceType),
                    mode: this.mode,
                }
                if (this.formInline.stageId !== '' && this.formInline.stageId != null) {
                    params.stageId = this.formInline.stageId
                }
                if (this.mode === 'detail' && this.formInline.statusCode) {
                    params.statusCode = this.formInline.statusCode
                }
                if (this.formInline.keyword) {
                    params.keyword = this.formInline.keyword.trim()
                }
                if (withPage) {
                    params.page = this.pages.currentPage
                    params.limit = this.pages.pageSize
                }
                return params
            },
            getDefaultDailyDate(dates) {
                const list = (dates || []).slice().sort()
                const todayStr = formatDate(new Date())
                if (!list.length) return todayStr
                if (list.indexOf(todayStr) !== -1) return todayStr
                const pastDates = list.filter(dateStr => dateStr <= todayStr)
                if (pastDates.length) return pastDates[pastDates.length - 1]
                return list[list.length - 1]
            },
            collectAttendanceDates(stageList) {
                const dateSet = {}
                ;(stageList || []).forEach(item => {
                    if (Number(item.enabled) !== 1) return
                    ;(item.morningDates || []).forEach(date => { dateSet[date] = true })
                    ;(item.stayDates || []).forEach(date => { dateSet[date] = true })
                })
                return Object.keys(dateSet).sort()
            },
            updateTip() {
                if (!this.formInline.date) {
                    this.tipText = '请选择日期查看当日考勤'
                    return
                }
                const typeName = Number(this.attendanceType) === 2 ? '住宿考勤' : '上午考勤'
                const modeName = this.mode === 'missing' ? '未打卡名单' : '考勤明细'
                this.tipText =
                    `<strong>${this.headerDateText}</strong>` +
                    ` · ${typeName} · ${modeName} · 共 <strong>${this.pages.total}</strong> 条`
            },
            onTypeChange() {
                this.pages.currentPage = 1
                this.fetchList()
            },
            onModeChange() {
                this.formInline.statusCode = ''
                this.pages.currentPage = 1
                this.fetchList()
            },
            onFilterChange() {
                this.pages.currentPage = 1
                this.fetchList()
            },
            onSearchInput() {
                if (this.searchTimer) clearTimeout(this.searchTimer)
                this.searchTimer = setTimeout(() => {
                    this.onFilterChange()
                }, 300)
            },
            handlePageChange(data) {
                this.pages.currentPage = data.pageIndex
                this.pages.pageSize = data.pageSize
                this.fetchList()
            },
            async fetchStages() {
                const [stageRes, enabledRes] = await Promise.all([
                    this.$Api.StageV2.getStageList({ projectId: this.projectId }),
                    this.$Api.AttendanceV2.getEnabledStages({ projectId: this.projectId }),
                ])
                const stageList = Array.isArray(stageRes.data) ? stageRes.data : []
                this.attendanceDates = this.collectAttendanceDates(stageList)
                this.stageOptions = Array.isArray(enabledRes.data) ? enabledRes.data : []
            },
            async fetchList() {
                if (!this.projectId || !this.formInline.date) return
                this.loading = true
                try {
                    const res = await this.$Api.AttendanceV2.getDaily(this.buildQueryParams(true))
                    const data = res.data || {}
                    this.tableData = data.records || []
                    this.pages.total = data.total || 0
                    this.updateTip()
                } catch (e) {
                    this.tableData = []
                    this.pages.total = 0
                    this.updateTip()
                } finally {
                    this.loading = false
                }
            },
            escapeCsv(value) {
                const str = value == null || value === '' ? '' : String(value)
                if (/[",\n\r]/.test(str)) {
                    return `"${str.replace(/"/g, '""')}"`
                }
                return str
            },
            async exportDaily() {
                if (!this.formInline.date) {
                    this.$message.warning('请先选择日期')
                    return
                }
                this.exporting = true
                try {
                    const params = this.buildQueryParams(false)
                    params.page = 1
                    params.limit = 9999
                    const res = await this.$Api.AttendanceV2.getDaily(params)
                    const records = (res.data && res.data.records) || []
                    if (!records.length) {
                        this.$message.warning('暂无数据可导出')
                        return
                    }
                    const isMissing = this.mode === 'missing'
                    const headers = isMissing
                        ? ['序号', '日期', '教师姓名', '手机号', '所在学校', '所属阶段', '应打卡时段', '打卡状态']
                        : ['序号', '日期', '教师姓名', '手机号', '所在学校', '所属阶段', '应打卡时段', '打卡状态', '打卡时间', '打卡位置']
                    const rows = records.map((item, index) => {
                        const row = [
                            index + 1,
                            item.expectDate || this.formInline.date,
                            item.userName,
                            item.phone,
                            item.schoolName,
                            item.stageName,
                            item.expectTimeRange,
                            item.statusName,
                        ]
                        if (!isMissing) {
                            row.push(item.checkTime, item.location)
                        }
                        return row.map(this.escapeCsv).join(',')
                    })
                    const csvContent = '\uFEFF' + [headers.join(','), ...rows].join('\n')
                    const typeName = Number(this.attendanceType) === 2 ? '住宿考勤' : '上午考勤'
                    const prefix = isMissing ? '未打卡名单' : '每日考勤'
                    saveAs(
                        new Blob([csvContent], { type: 'text/csv;charset=utf-8;' }),
                        `${prefix}_${typeName}_${this.formInline.date}.csv`
                    )
                } catch (e) {
                    this.$message.error('导出失败，请稍后重试')
                } finally {
                    this.exporting = false
                }
            },
            applyRouteQuery() {
                const query = this.$route.query || {}
                if (query.phone) {
                    this.formInline.keyword = String(query.phone)
                }
                if (query.date && /^\d{4}-\d{2}-\d{2}$/.test(query.date)) {
                    this.formInline.date = query.date
                } else {
                    this.formInline.date = this.getDefaultDailyDate(this.attendanceDates)
                }
                if (query.attendanceType === '0' || query.attendanceType === '2') {
                    this.attendanceType = String(query.attendanceType)
                }
                if (query.mode === 'detail' || query.mode === 'missing') {
                    this.mode = query.mode
                }
            },
        },
        async mounted() {
            if (!this.projectId) return
            this.loading = true
            try {
                await this.fetchStages()
                this.applyRouteQuery()
                await this.fetchList()
            } finally {
                this.loading = false
            }
        },
        beforeDestroy() {
            if (this.searchTimer) clearTimeout(this.searchTimer)
        },
    }
</script>

<style lang="less" scoped>
    @import "../manage/less/table.less";

    .attendance-manage {
        padding: 20px 25px;
        box-sizing: border-box;

        /deep/ .el-tabs__content {
            padding: 0;
            display: none;
        }

        .page-header {
            margin: 8px 0 4px;
        }

        .page-title {
            font-size: 15px;
            font-weight: 600;
            color: #303133;
        }

        .header-date {
            font-size: 14px;
            font-weight: 500;
            color: #303133;

            .weekday {
                margin-left: 6px;
                color: #909399;
                font-weight: 400;
            }
        }

        .demo-form-inline {
            width: 100%;
            margin: 10px 0 12px;

            /deep/ .el-form-item {
                margin-bottom: 8px;
            }
        }

        .daily-tip {
            padding: 10px 14px;
            margin-bottom: 12px;
            font-size: 13px;
            color: #606266;
            background: #FAFAFA;
            border: 1px solid #EBEEF5;
            border-radius: 4px;

            /deep/ strong {
                color: #303133;
                font-weight: 500;
            }
        }

        .status-badge {
            display: inline-block;
            padding: 2px 8px;
            border-radius: 10px;
            font-size: 12px;
            font-weight: 500;
            white-space: nowrap;

            &.checked {
                background: #DCFCE7;
                color: #16A34A;
            }

            &.missing {
                background: #FEE2E2;
                color: #DC2626;
            }

            &.late {
                background: #FEF3C7;
                color: #D97706;
            }

            &.leave {
                background: #F3F4F6;
                color: #6B7280;
            }

            &.pending {
                background: #E0F2FE;
                color: #0284C7;
            }
        }
    }
</style>
